export default __webpack_public_path__ + "static/brokerage-sales-490afc3d3e24a28af8b2fbc869c7542e.png";